import { Box, Text } from "@chakra-ui/layout";

interface TagStatusEncomendaProps {
  status: string;
}

export default function TagStatusEncomenda({
  status,
}: TagStatusEncomendaProps) {
  return (
    <Box>
      {status ? (
        <Text bg={"gray.100"} fontSize={13} px={3} py={1} rounded={20}>
          {status}
        </Text>
      ) : null}
    </Box>
  );
}
